import { Alert } from '@mui/material';
import {
    hasProcessedTimesheetLocationMismatch,
    LOCATION_MISMATCH_WARNING_MESSAGE,
} from '../../Utils/hasProcessedTimesheetLocationMismatch';

export default function LocationMismatchBanner({ timesheetDetails }) {
    if (!hasProcessedTimesheetLocationMismatch(timesheetDetails)) {
        return null;
    }

    return (
        <Alert severity="warning" data-testid="location-mismatch-banner">
            {LOCATION_MISMATCH_WARNING_MESSAGE}
        </Alert>
    );
}
